import React, { Component } from 'react';
import OwlCarousel from 'react-owl-carousel';
import { translate } from "react-translate";
import { render } from 'react-dom'
import ReactSVG from 'react-svg'
import { connect } from "react-redux";
import { Link } from 'react-router-dom'

import {
    Segment,
    Image,
    Container,
    Header
} from 'semantic-ui-react';

import './landing.css'
import './secondcarousel.css'

import image_hotte from '../../../assets/tmp/Hotte_icon.png'
import image_mur from '../../../assets/tmp/Murs_icon.png'
import image_plantes from '../../../assets/tmp/Plantes_icon.png'
import image_reduction from '../../../assets/tmp/Reduction_icon.png'
import image_sols from '../../../assets/tmp/Sols_icon.png'
import workSvg from '../../../assets/icons_works/1.svg'

import API from '../../../services/api';

const mapStateToProps = state => ({
    app: state.app
})

class ConnectedCarouselComponent extends Component {

    constructor(props) {
        super(props);

        this.state = {
            configFile: null
        }
    }


    componentWillMount() {
        var self = this;
        var envData = {
            status: this.state.status,
            lang: this.props.app.lang
        };
        API.getEnv(this.props.app.token, envData).then((res) => {
            API.getConfigFile(res.data.link).then((configFileRes) => {
                self.setState({
                    configFile: configFileRes.data
                })
            });
        });
    }

    render() {

        const owl = {
            0: {
                items: 1,
                loop: true
            },
            800: {
                items: 3,
                loop: true
            },
            1200: {
                items: 5,
                loop: true
            }
        }

        let text = [
            '<i aria-hidden="true" class="angle left icon"></i>',
            '<i aria-hidden="true" class="angle right icon"></i>'
        ]

        const { t } = this.props;
        let carou = []


        if (this.state.configFile) {
            Object.entries(this.state.configFile).map((key, Mainindex) => {
                let objet = {};
                if (key[0] === "ListWorks") {
                    Object.entries(key[1]).map((key, MainindexFirst) => {
                        objet.image = key[1].Icon.slice(0, -3) + "svg"
                        objet.id = key[1].WorkId
                        objet.name = key[1].Work[this.props.app.lang]
                        carou[MainindexFirst] = objet

                        objet = {};
                    })
                }
            })

            let reloadConfigFile = true
            Object.entries(this.state.configFile.Changes).map((key, Mainindex) => {
                if (this.props.app.lang == key[0]) {
                    reloadConfigFile = false;
                }
            })
            if (reloadConfigFile) {
                this.componentWillMount()
            }
        }

        return (
            <div>
                {
                    carou.length > 0 ? (
                        <OwlCarousel
                            className="owl-theme"
                            responsive={owl}
                            dots={false}
                            nav
                            center={true}
                            navText={text}
                        >
                            {
                                carou.map((x, i) => {

                                    return (
                                        <div key={i} className="item">
                                          <Link to={'/works/'+ x.id} >
                                            <div className="single-testimonial">
                                                <div className="testimonials-wrapper">
                                                    <div className="testimonials-img">
                                                        <Image
                                                            centered
                                                            className = "svg" 
                                                            src={API.resourceURL + '/upload/iconsworks/' + x.image}
                                                        /> 
                                                    </div>
                                                    <div className="testimonials-shadow"></div>
                                                    <div className="testimonials-person-info">
                                                        <p>{x.name}</p>
                                                    </div>
                                                </div>
                                            </div>
                                          </Link>
                                        </div>

                                    )
                                })
                            }
                        </OwlCarousel>

                    ) : (
                            <div></div>
                        )
                }
            </div>

        );
    }
}

const CarouselComponent = connect(mapStateToProps)(ConnectedCarouselComponent)
export default translate("LandingComponent")(CarouselComponent);



// WEBPACK FOOTER //
// ./src/components/Public/LandingPage/CarouselComponent.js